<template>
    <div class="multi-select" :id="id">
        <!--TODO: use native select on mobiles ?-->
        <BasicButton :class="{'is-active':isOpen}" class="multi-select__button no-selectable" size="medium"
                     type="grey-transparent"
                     @click="toggleMenu">{{label}} <span>
            <i :class="{'arrow-rotate':isOpen}" class="pull-right icons8-joblist-sort-down-01 drop-down-arrow"></i>
        </span>
        </BasicButton>
        <div class="list-wrapper" :class="{show: isOpen}">
            <div class="list-grid" v-if="multirow">
                <ul class="list--unstyled" v-for="(block, index) in list" :key="index">
                    <li v-for="item in block" :key="item.id" @click="toggleItem(item)"
                        :class="{active: activeItemsIds.indexOf(item.id) >= 0}">
                        <button type="button"><span class="dot" v-if="activeItemsIds.indexOf(item.id) >= 0"></span>
                            {{item.name}}
                        </button>
                    </li>
                </ul>
            </div>
            <div v-else>
                <ul class="list--unstyled">
                    <li v-for="item in list" :key="item.id" @click="toggleItem(item)"
                        :class="{active: activeItemsIds.indexOf(item.id) >= 0}">
                        <button type="button"><span class="dot" v-if="activeItemsIds.indexOf(item.id) >= 0"></span>
                            {{item.name}}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  import { addItem, removeItem } from "../../utils/filters";
  import BasicButton from "../BasicButton";

  export default {
    name: "multiple-select",
    components: {
      BasicButton
    },
    props: {
      label: String,
      list: Array,
      value: Array,
      multirow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false
      };
    },
    computed: {
      activeItemsIds() {
        return this.value.map(item => item.id);
      },
      id() {
        return "multiselect-" + this.label.replace(" ", "");
      }
    },
    methods: {
      toggleItem(item) {
        const isItemActive = this.value.find(i => i.id === item.id);

        if (isItemActive) {
          this.removeActive(isItemActive.id);
        } else {
          this.setActive(item);
        }
      },
      removeActive(id) {
        this.sendChanges(
          removeItem(this.value, id)
        );
      },
      setActive(item) {
        this.sendChanges(
          addItem(this.value, item)
        );
      },
      sendChanges(list) {
        this.$emit("input", list);
      },
      toggleMenu() {
        this.isOpen = !this.isOpen;
      },
      closeOnClickOutside({ target }) {
        if (!target.closest("#" + this.id)) {
          this.isOpen = false;
        }
      }
    },
    watch: {
      isOpen(val) {
        if (val) {
          window.addEventListener("click", this.closeOnClickOutside);
        } else {
          window.removeEventListener("click", this.closeOnClickOutside);
        }
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/mixins";
    @import "../../assets/scss/globals";

    .drop-down-arrow {
        transition: transform 1s;
        -webkit-transition: transform 1s;
        font-size: 28px;
        margin-left: 14px;
    }

    .arrow-rotate {
        transform: rotate(180deg);
    }

    .multi-select__button {
        @media(max-width: 1200px) {
            padding-left: 15px;
            padding-right: 5px;
            .drop-down-arrow {
                margin-left: 4px;
            }
        }

    }

    .multi-select {
        position: relative;
        display: inline-block;

        &__button {
            width: 100%;
        }
    }

    .list-grid {
        display: flex;
        max-width: 600px;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;

        ul {
            padding-right: 5px;
            padding-left: 5px;
        }
    }

    .list-wrapper {
        position: absolute;
        z-index: 12;
        background-color: #fff;
        border-radius: 4px;
        color: #444;
        transform: translateY(-10px);
        -webkit-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.15);
        visibility: hidden;
        opacity: 0;
        transition: 0.3s ease-in-out;
        transition-property: opacity, transform, visibility;
        padding: 18px;

        &:before {
            content: " ";
            width: 0;
            height: 0;
            position: absolute;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid white;
            top: -4px;
        }

        &.show {
            visibility: visible;
            opacity: 1;
            transform: translateY(10px);
        }
    }

    ul {
        margin: 0;
        padding: 0;
    }

    .dot {
        height: 6px;
        width: 6px;
        vertical-align: middle;
        background-color: $text-blue;
        border-radius: 50%;
        display: inline-block;
        margin-left: -4px;
        margin-right: 8px;
    }

    li {
        white-space: nowrap;
        line-height: 2;

        button {
            @include button-reset;
            position: relative;
            font-family: $font-paragraphs;
            font-size: 1.1rem;
            display: block;
            width: 100%;
            padding: 0 0.75em;
            text-align: left;
            transition: all 0.2s ease-in-out;
            @media (max-width: $compact) {
                font-size: 0.95rem;
            }

            span {
                transition: transform 0.2s ease-in-out;
            }

            &:focus {
                color: $text-blue;
            }

            &:hover {
                color: black;
            }
        }

        &.active {
            font-weight: bold;
            color: $text-blue;

            span {
                display: inline-block;
                transform: translateX(5px);
            }
        }

    }

    .is-active {
        border-color: $text-blue !important;

        &:hover {
            background-color: #fff !important;
            color: $darker-gray !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/MultipleSelect.vue